import { render, staticRenderFns } from "./ParametrosPadrao.vue?vue&type=template&id=1d000cd0&lang=pug"
import script from "./ParametrosPadrao.vue?vue&type=script&lang=js"
export * from "./ParametrosPadrao.vue?vue&type=script&lang=js"
import style0 from "./ParametrosPadrao.vue?vue&type=style&index=0&id=1d000cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports